import type { MyBookingListItem } from '@massilia/queries'

import { BookingListItem } from './booking-list-item'

interface BookingListProps {
  bookings: MyBookingListItem[]
}

export function BookingList({ bookings }: BookingListProps) {
  return (
    <div className="flex flex-col gap-4">
      {bookings.map((booking) => (
        <BookingListItem booking={booking} key={booking.id} />
      ))}
    </div>
  )
}
